import React from "react";
import i18n from "../lib/i18n";
import PieChart from "./PieChart";
import KPIBox from "./KPIBox";
import { array, arrayOf, number, string } from "prop-types";

const AnalysisPieChart = ({ cols = 4, series, name, colors }) => (
  <div className={`col-xs-12 col-md-${cols}`}>
    <KPIBox
      title={i18n.t("js.components.analysis_pie_chart.title", { name: name })}
    >
      <div className="analysis-pie-chart">
        <PieChart series={series} colors={colors} />
      </div>
    </KPIBox>
  </div>
);

export default AnalysisPieChart;

AnalysisPieChart.prototypes = {
  cols: number,
  series: arrayOf(array).isRequired,
  title: string,
  tooltip: string,
};
